<template>
  <div class="error-page">
    <app-navbar></app-navbar>
    <section class="content">
      <div class="message-container">
        <h2>Ops! A página que você procura não foi encontrada.</h2>
        <router-link :to="{ name: 'site.index' }">
          Clique aqui para ser redirecionado!
        </router-link>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppNavbar from '@/components/Layout/AppNavbar.vue';
import AppFooter from '@/components/Layout/AppFooter.vue';

export default {
  name: 'error-page',
  components: {
    AppNavbar,
    AppFooter,
  },
};
</script>

<style lang="scss" scoped>
section.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  .message-container {
    text-align: center;
  }
}
</style>
